
import React, { createContext, useContext, useState } from "react";
import { TAB_INFO } from "../../../constants/constants";

interface ProvidedProps {
  children: React.ReactNode;
}

interface brandTabsContext {
  productID: string;
  activeTab: string;
  setProductID: React.Dispatch<React.SetStateAction<string>>;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  reloadProducts: boolean;
  setReloadProducts: React.Dispatch<React.SetStateAction<boolean>>;
}



const BrandTabsContext = createContext<brandTabsContext>({
  productID: "",
  activeTab: "",
  setProductID: () => { },
  setActiveTab: () => { },
  reloadProducts: false,
  setReloadProducts: () => { },
});

export const BrandTabsContextProvider = (
  props: ProvidedProps
) => {

  const [productID, setProductID] =
    useState<string>("");
  const [activeTab, setActiveTab] =
    useState<string>(TAB_INFO);

  const [reloadProducts, setReloadProducts] =
    useState<boolean>(false);

  return (
    <BrandTabsContext.Provider value={{ productID, setProductID, activeTab, setActiveTab, reloadProducts, setReloadProducts }}>
      {props.children}
    </BrandTabsContext.Provider>
  );
};

export const useBrandTabsContext = () => {
  return useContext(BrandTabsContext);
};
